import { Col, Container, Row } from "react-bootstrap";

import "./notificationStyles.css";

const Notification = ({ text, buttonLabel, link, closeToast }) => {
  const onClick = () => {
    const newWindow = window.open(link, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;

    closeToast();
  };

  return (
    <Container className="px-1">
      <Row className="notification align-items-center">
        <Col xs={8} className="px-3 text-center">
          <span>{text}</span>
        </Col>
        <Col className="button-col text-right px-0">
          <button onClick={onClick}>{buttonLabel}</button>
        </Col>
      </Row>
    </Container>
  );
};

export default Notification;
